import type {Point} from '@yandex-delivery/core/types'

import type {AppConfig} from '../../../types'

export function getCoordinates(type: 'source' | 'destination', config: AppConfig): Point {
  const {to, zoneName, zonePoint, from} = config.initialProps
  /** проверяем, пришли ли координаты в квери-параметрах */
  if (from && type === 'source') {
    return from
  }

  /** to без from не должен работать */
  if (from && to && type === 'destination') {
    return to
  }

  /**
   * проверяем, пришла ли зона в пути и нашли ли мы ее в seo-конфиге
   * если есть zoneName, значит зона пришла и найдена, можно вернуть ее координаты
   */
  if (zoneName) {
    return zonePoint
  }

  return config.location
}
